@if (useLazyLoad || isLoaded) {
  <sd-arguments
    [sdSpyTarget]="componentUid"
    [data]="arguments"
    [themesConfig]="themesConfig"
    [layoutTextConfig]="layoutTextConfig"
    [textConfig]="textConfig"
    [titleLevel]="titleLevel"
    [isSmall]="isSmall"
    [imageRatio]="imageRatio"
    [layout]="layout"
    [hasGradient]="hasGradient"
    (clicked)="onClicked($event)"
    (videoPlayed)="onVideoAction($event)"
    (videoEnded)="onVideoAction($event)"
    [twicPicsAutoSize]="!isFirst"
    [brand]="brandCorner"
    [activeBrand]="activeBrand"
    [isLoading]="useLazyLoad && !isLoaded"
  />
}
